var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 43,
    viewBox: "0 0 25 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.936113 0.936113C0.33672 1.53569 0 2.34877 0 3.19657C0 4.04437 0.33672 4.85746 0.936113 5.45703L16.7625 21.2834L0.936113 37.1099C0.353707 37.7129 0.0314409 38.5205 0.0387256 39.3588C0.0460103 40.1971 0.382263 40.999 0.975059 41.5918C1.56786 42.1846 2.36977 42.5209 3.20808 42.5282C4.04638 42.5354 4.85402 42.2132 5.45703 41.6308L23.5439 23.5439C24.1433 22.9443 24.48 22.1312 24.48 21.2834C24.48 20.4356 24.1433 19.6226 23.5439 19.023L5.45703 0.936113C4.85745 0.33672 4.04437 0 3.19657 0C2.34877 0 1.53569 0.33672 0.936113 0.936113Z",
    fill: "#058998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/Arrow right.e7bc5adc109def6c07010e28859856d4.svg";
export { ForwardRef as ReactComponent };